import {Component} from 'react';
import PropTypes from 'prop-types';

/*
	This component provides a technique for setting timeouts in your render function.
	The timeouts get cleared as soon as you re-render (or unmount), so you don't
	have to keep track of them. 

	The idea is that a timeout should be a function of state (ie. state A automatically
	advances to state B after 5s), and as soon as you change state (ie. state A moves
	to state C on click of button) the timeout should be cleared.

	The reset_prevention_key prop can be used when certain state transitions should 
	not cause the timeout to reset (or if your component might be rendered multiple
	times in the same state).

	Note - we could change this implementation so that the on_timeout callback
	is always called from within a React event handler.
	We'd create an invisible element, with a css transition, and attach the
	callback to the element's onTransitionEnd.
	
	I'm not sure if that has too much advantage, though.
*/

export default class Timer extends Component {
	constructor(props) {
		super(props);
		this.timeout_id = null;
	}

	shouldComponentUpdate(nextProps, nextState) {
		return nextProps.reset_prevention_key === null || 
			nextProps.reset_prevention_key !== this.props.reset_prevention_key;
	}

	componentWillUnmount() {
		this.clear_timeout();
	}

	clear_timeout() {
		if (this.timeout_id !== null) {
			clearTimeout(this.timeout_id);
		}
		this.timeout_id = null;
	}

	render() {
		const {on_timeout, delay} = this.props;
		this.clear_timeout();
		this.timeout_id = setTimeout(on_timeout, delay);
		return null;
	}
}
Timer.propTypes = {
	on_timeout: PropTypes.func.isRequired,
	delay: PropTypes.number.isRequired,

	/*
		By default, Timer will reset its timeout on every render.
		If you want to prevent this, you can pass in a value to this prop.
		If this prop is not null and compares strictly equal on multiple
		consecutive renders, then the timeout will not be reset.
		(Note that you can other falsy values, like 0 or false, to prevent reset)
	*/
	reset_prevention_key: PropTypes.any,
}
Timer.defaultProps = {
	// Passing null or no value at all (undefined) should be treated the same
	reset_prevention_key: null,
}



// WEBPACK FOOTER //
// ./src/Timer.js